import { useState, useEffect } from "react";
import { InputField } from "../common";
import { toast } from "react-toastify";
import useApi from "../../api";

interface QuantityEditorProps {
  quantity: number;
  variant_id: number;
  warehouse_id: number;
  onSave?: () => void; // Optional callback for after save action
}

function QuantityEditor({ quantity, variant_id, warehouse_id, onSave }: QuantityEditorProps) {
  const [editedQuantity, setEditedQuantity] = useState(quantity);
  const [isChanged, setIsChanged] = useState(false);
  const api = useApi();

  useEffect(() => {
    // Reset isChanged if editedQuantity matches the initial quantity
    setIsChanged(editedQuantity !== quantity);
  }, [editedQuantity, quantity]);

  const handleSave = (e: any) => {
    e.preventDefault();
    const payload = [
      {
        quantity: editedQuantity,
        warehouse: warehouse_id,
      },
    ];

    api.updateStockWarehouseWise(variant_id, payload).then(
      (response: any) => {
        toast.success("Stock updated successfully!");
        setIsChanged(false); // Disable Save button after saving
        if (onSave) onSave(); // Trigger optional callback
      },
      (error) => {
        toast.error("Failed to update stock!");
      }
    );
  };

  return (
    <div className="flex items-center gap-2">
      <InputField
        className="border-3"
        type="number"
        value={editedQuantity}
        onChange={(e) => setEditedQuantity(Number(e.target.value))}
      />
      <button
        className={`px-2 py-1 rounded ${isChanged ? "bg-primary-500 text-white" : "bg-gray-300 text-gray-500 cursor-not-allowed"}`}
        onClick={handleSave}
        disabled={!isChanged} // Disable button if no changes
      >
        Save
      </button>
    </div>
  );
}

export default QuantityEditor;
